import { render, staticRenderFns } from "./PTV_trafficFlow.vue?vue&type=template&id=5b86239b&scoped=true"
import script from "./PTV_trafficFlow.vue?vue&type=script&lang=js"
export * from "./PTV_trafficFlow.vue?vue&type=script&lang=js"
import style0 from "./PTV_trafficFlow.vue?vue&type=style&index=0&id=5b86239b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86239b",
  null
  
)

export default component.exports